module.exports = __webpack_public_path__ + "img/R01_02.89bd1b96.svg";